export const style = {
  container: {
    margin: '0 auto',
    padding: '0 var(--container-offset)',
    width: 'min(100%, var(--content-width))',
  }
}